export const path = "/motor-de-inyeccion";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MOTOR DE INYECCION",
  section: "ALUNA",
  group: null,
  order: 11,
  roles: ["Authenticated", "aluna", "aluna-management"],
};
